import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-app-public',
  templateUrl: './app-public.component.html',
  styleUrls: ['./app-public.component.scss']
})
export class AppPublicComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
